import axios from 'axios'

function apiExtSuccessCallback(response){
  return Promise.resolve(response)
}

function apiExtErrorCallback(error){
  return Promise.reject(error.response)
}

export function postOAuthApp({data}){
  return axios.post('/oauth/applications/ajax',data)
      .then(apiExtSuccessCallback)
      .catch(apiExtErrorCallback)
}

export function patchOAuthApp({id,data}){
  return axios.patch(`/oauth/applications/${id}/ajax`,data)
      .then(apiExtSuccessCallback)
      .catch(apiExtErrorCallback)
}

export function s3new ({}){
  return axios.get('/oauth/s3/new',{withCredentials: true})
      .then(apiExtSuccessCallback)
      .catch(apiExtErrorCallback)
}


// WEBPACK FOOTER //
// app/javascript/components/api.js